<template>
  <div class="mainRight pageContainer flexCloumn" style="overflow-y:auto;padding-top:0;">
    <div v-if="!ccstatus" style="width:100%;">
      <div class="companyInfo" :style="{ paddingTop: companyInfo.checkStatus == '2' ? '30px' : '' }">
        <div class="baseInfo">
          <h3 style="margin:0">
            <p style="margin:0">
              企业基本信息
              <span style="color: red;font-size: 20px;" v-if="companyInfo.check_status == '2'">
                认证失败原因:{{ companyInfo.remarks }}
                <el-button @click="recertification" style="margin-left: 35px;" type="primary" plain>重新认证</el-button>
              </span>
            </p>
          </h3>
          <div style="position: relative">
            <img v-if="companyInfo.check_status == '1'" class="state-pic" src="../../assets/success.png" alt />
            <img v-else-if="companyInfo.check_status == '2'" class="state-pic" src="../../assets/fail.png" alt />
          </div>
          <ul>
            <li>
              <b>企业名称：</b>
              <span>{{ companyInfo.firm_name ? companyInfo.firm_name : "-" }}</span>
            </li>
            <li>
              <b>统一社会信用代码：</b>
              <span>{{ companyInfo.firm_num ? companyInfo.firm_num : "-" }}</span>
            </li>
            <li>
              <b>企业法人：</b>
              <span>{{ companyInfo.legal_person ? companyInfo.legal_person :
                (companyInfo.tyc && companyInfo.tyc.tyc_json ? companyInfo.tyc.tyc_json.legalPersonName : "-") }}</span>
            </li>
            <li>
              <b>企业邮编：</b>
              <span>{{ companyInfo.enter_postcode ? companyInfo.enter_postcode : "-" }}</span>
            </li>
            <li>
              <b>成立日期：</b>
              <span>{{ companyInfo.establish_date ? companyInfo.establish_date :
                (companyInfo.tyc && companyInfo.tyc.tyc_json && companyInfo.tyc.tyc_json.estiblishTime ?
                $moment(companyInfo.tyc.tyc_json.estiblishTime).format("YYYY-MM-DD") : "-") }}</span>
            </li>
            <li>
              <b>注册资本：</b>
              <span>{{ companyInfo.register_capital ? `${companyInfo.register_capital}万元` :
                (companyInfo.tyc && companyInfo.tyc.tyc_json ? companyInfo.tyc.tyc_json.regCapital : "-") }}</span>
            </li>
            <li>
              <b>企业规模：</b>
              <span>{{ unitSize[companyInfo.unit_size] || (companyInfo.tyc && companyInfo.tyc.guimo ?
                companyInfo.tyc.guimo : "-") }}</span>
            </li>
            <li>
              <b>企业性质：</b>
              <span>{{ qyxz[companyInfo.info] ? qyxz[companyInfo.info].param_desc :
                (companyInfo.tyc && companyInfo.tyc.enter_type ? companyInfo.tyc.enter_type : '-') }}</span>
            </li>
            <li>
              <b>所属行业：</b>
              <span>{{ companyInfo.industry_name ? companyInfo.industry_name : "-" }}</span>
            </li>
            <li>
              <b>所在地区：</b>
              <span>{{ companyInfo.cityName ? companyInfo.cityName : "-" }}</span>
            </li>
            <li>
              <b>企业地址：</b>
              <span>{{ companyInfo.address ? companyInfo.address : "-" }}</span>
            </li>
            <li class="flexStartUp">
              <b style="flex-shrink:0;">企业简介：</b>
              <span v-if="!edit_desc" style="margin-left:0;word-break:break-all;">{{ companyInfo.enter_desc ?
                companyInfo.enter_desc : "-"
                }}</span>
              <span v-if="!edit_desc" @click="edit_desc=true" style="margin-left: 21px;color:#3378fa;cursor:pointer;">
                <i class="el-icon-edit" style="margin-left:10px" />编辑
              </span>
              <el-input v-if="edit_desc" class="input_css" type="textarea" placeholder="请输入企业简介" maxlength="500"
                show-word-limit rows="5" v-model="companyInfo.enter_desc"></el-input>
            </li>
            <li v-if="edit_desc" class="flexStartUp" style="margin-top:5px;">
              <b style="flex-shrink:0;"></b>

              <el-button plain @click="edit_desc = false; companyInfo.enter_desc = initEnterDesc">取消</el-button>
              <el-button type="primary" plain @click="saveDesc">保存</el-button>
            </li>
            <li>
              <b>营业执照：</b>
              <span style="width: 96px;height: 96px;overflow: hidden">
                <el-image style="width: 100px; height: 100px"
                  :src="companyInfo.license_imge ? companyInfo.license_imge : 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'"
                  :preview-src-list="[companyInfo.license_imge ? companyInfo.license_imge : 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg']"></el-image>
              </span>
            </li>
          </ul>
        </div>
        <div class="contactInfo">
          <h3>
            <p>
              企业联系信息
              <b>
                <em v-if="edit"></em>
                <span v-else @click="editInfo" style="margin-right: 21px">
                  <i class="el-icon-edit" style="margin-right: 10px" />编辑
                </span>
              </b>
            </p>
          </h3>
          <ul v-if="!edit">
            <li>
              <b>企业联系人：</b>
              <span>{{ companyInfo.firm_principal ? companyInfo.firm_principal : "-" }}</span>
            </li>
            <li>
              <b>职务：</b>
              <span>{{ companyInfo.job ? companyInfo.job : "-" }}</span>
            </li>
            <li>
              <b>联系电话：</b>
              <span>{{ companyInfo.tel ? companyInfo.tel : "-" }}</span>
            </li>
            <li>
              <b>电子邮箱：</b>
              <span>
                {{ companyInfo.email ? companyInfo.email : "-" }}
                <el-link v-if="companyInfo.email_status === 0" style="margin-left: 20px" @click="sendVerifyEmail"
                  type="primary">点击重新发送验证邮件</el-link>
                <el-link v-if="companyInfo.email_status === 1" style="margin-left: 20px" type="success">已认证</el-link>
              </span>
            </li>
          </ul>
          <ul v-if="edit">
            <el-form :model="form" ref="form" label-width="120px">
              <el-form-item label="企业联系人：" prop="job_name">
                <el-input style="width: 90%;" v-model="form.firm_principal" placeholder="请输入企业联系人"></el-input>
              </el-form-item>
              <el-form-item label="职务：" prop="job">
                <el-input style="width: 90%;" v-model="form.job" placeholder="请输入职务"></el-input>
              </el-form-item>
              <el-form-item label="联系电话：" prop="job_name">
                <el-input style="width: 90%;" v-model="form.tel" placeholder="请输入联系电话"></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱：" prop="job_name">
                <el-input style="width: 90%;" v-model="form.email" placeholder="请输入电子邮箱"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button plain @click="cancel">取消</el-button>
                <el-button type="primary" plain @click="save">保存</el-button>
              </el-form-item>
            </el-form>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="ccstatus" style="width:100%;">
      <el-form :model="companyInfo" :rules="rules" ref="companyInfo" label-width="100px">
        <el-row>
          <el-col :span="10">
            <el-form-item class="license_imge_css" prop="license_imge">
              <el-upload action :http-request="uploadOss" :on-success="uploadCover" :show-file-list="false" name="image"
                style="margin-left:-100px;">
                <i v-if="companyInfo.license_imge == ''" class="el-icon-upload" style="font-size:50px;"></i>
                <div v-if="companyInfo.license_imge == ''" class="el-upload__text">上传营业执照(格式为*.png/*.jpeg/*.jpg等)</div>
                <img v-if="companyInfo.license_imge !== ''" :src="companyInfo.license_imge"
                  style="width: 100%;height: 256px;" />
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="14" class="enter_form">
            <el-form-item label="企业LOGO:" prop="logo">
              <el-upload action :http-request="uploadOss" :on-success="logoUploadCover" :show-file-list="false"
                name="image">
                <el-avatar :size="150" style="margin-left: 80px;">
                  <img v-if="companyInfo.logo !== ''" :src="companyInfo.logo" style="width: 100%;height: 256px;" />
                  <i style="font-size:50px;padding-top: 49px;" class="el-icon-plus avatar-uploader-icon"></i>
                </el-avatar>
              </el-upload>
            </el-form-item>
            <el-form-item label="企业名称:" prop="firm_name">
              <el-input class="input_css" v-model="companyInfo.firm_name" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="组织机构代码:" prop="firm_num">
              <el-input class="input_css" v-model="companyInfo.firm_num" placeholder="请输入组织机构代码"></el-input>
            </el-form-item>
            <el-form-item label="企业法人代表:" prop="legal_person">
              <el-input class="input_css" v-model="companyInfo.legal_person" placeholder="请输入企业法人代表"></el-input>
            </el-form-item>
            <el-form-item label="企业邮编:" prop="enter_postcode">
              <el-input class="input_css" v-model="companyInfo.enter_postcode" placeholder="请输入企业邮编"></el-input>
            </el-form-item>
            <el-form-item label="成立日期:" prop="establish_date">
              <el-date-picker class="input_css" v-model="companyInfo.establish_date" type="date"
                value-format="yyyy-MM-dd" placeholder="选择成立日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="注册资本:" prop="register_capital">
              <el-input-number class="input_css" controls-position="right" placeholder="请输入注册资本" :min="1"
                v-model="companyInfo.register_capital">
              </el-input-number> 万元
            </el-form-item>
            <el-form-item label="所在地区:" prop="area_id">
              <el-cascader class="input_css" v-model="companyInfo.area_id" ref="firstCascader" :options="cityOptions"
                :props="{ emitPath: false, checkStrictly: false }" :show-all-levels="false" placeholder="请选择所在地区"
                filterable clearable></el-cascader>
            </el-form-item>
            <el-form-item label="企业地址:" prop="address">
              <el-input class="input_css" v-model="companyInfo.address" placeholder="请输入企业地址"></el-input>
            </el-form-item>
            <el-form-item label="所属行业" prop="industry_id">
              <el-cascader class="input_css" v-model="companyInfo.industry_id" ref="firstCascader" :options="options"
                :props="{ value: 'id', label: 'industry_name', emitPath: false, checkStrictly: false }"
                :show-all-levels="false" placeholder="请选择所属行业" filterable clearable></el-cascader>
            </el-form-item>
            <el-form-item label="企业性质" prop="info">
              <el-cascader class="input_css" v-model="companyInfo.info" :options="qyxz"
                :props="{ value: 'param_value', label: 'param_desc' }" clearable placeholder="请选择企业性质"></el-cascader>
            </el-form-item>
            <el-form-item label="企业规模:" prop="unit_size">
              <el-select class="input_css" v-model="companyInfo.unit_size" placeholder="请选择" clearable>
                <el-option v-for="(v,k) in unitSize" :key="k" :label="v" :value="k">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="企业简介:" prop="enter_desc">
              <el-input class="input_css" type="textarea" placeholder="请输入企业简介" maxlength="500" show-word-limit rows="5"
                v-model="companyInfo.enter_desc"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="submit('companyInfo')" type="primary">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
//import citys from "../../utils/arae_value.js";
import citys  from '@/utils/area.json'
import util from "@/utils/util";

export default {
  components: {},
  data() {
    var validateAreaId = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择所在地区!"));
      } else {
        callback();
      }
    };
    var validateInfo = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择企业性质!"));
      } else {
        callback();
      }
    };
    var validateEnterDesc = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请填写企业简介!"));
      } else {
        callback();
      }
    };
    var validateIndustryId = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择所属行业!"));
      } else {
        callback();
      }
    };
    var validateAddress = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请填写企业地址!"));
      } else {
        callback();
      }
    };
    var validateLicenseImge = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请上传营业执照图片!"));
      } else {
        callback();
      }
    };
    var validateLogo = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请上传公司LOGO图片!"));
      } else {
        callback();
      }
    };
    var validateFirmNum = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请输入组织机构代码"));
      } else {
        callback();
      }
    };
    var validateFirmName = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请输入企业名称"));
      } else {
        callback();
      }
    };
    return {
      companyInfo: {
        firm_name: "",
        firm_num: "",
        info: "",
        industry_id: "",
        area_name: "",
        address: "",
        enter_desc: "",
        license_imge: "",
        firm_principal: "",
        tel: "",
        email: "",
        email_status: "",
        check_status: ""
      },
      form: {
        firm_principal: "",
        tel: "",
        email: ""
      },
      qyxz: [],
      unitSize: {},
      options: [],
      cityOptions: [],
      edit: false,
      ccstatus: false,
      rules: {
        firm_name: [{ validator: validateFirmName, trigger: "blur" }],
        firm_num: [{ validator: validateFirmNum, trigger: "blur" }],
        license_imge: [{ validator: validateLicenseImge, trigger: "blur" }],
        logo: [{ validator: validateLogo, trigger: "blur" }],
        address: [{ validator: validateAddress, trigger: "blur" }],
        industry_id: [{ validator: validateIndustryId, trigger: "blur" }],
        area_id: [{ validator: validateAreaId, trigger: "blur" }],
        enter_desc: [{ validator: validateEnterDesc, trigger: "blur" }],
        info: [{ validator: validateInfo, trigger: "blur" }]
      },
      edit_desc: false,
      initEnterDesc:'',
    };
  },
  mounted() {
    this.$http
      .post("/api/zp_industry_tree", { pmid: window.pmid })
      .then(res => {
        if (res && res.data && res.data.tree) {
          this.options = res.data.tree;
        }
      });
    this.getEnterInfo();
    this.getComType();
    this.cityOptions = citys;
  },
  methods: {
    getComType() {
      return new Promise(resolve => {
        this.$http
          .post("/api/sys_param_list", {
            param_type: "'ENTER_INFO','UNIT_SIZE'",
            used: 0
          })
          .then(res => {
            let qyxz = [];
            let unitSize = {}
            for (let item of res.data) {
              if (item.param_type == "ENTER_INFO") {
                qyxz.push(item);
              }
              if (item.param_type == "UNIT_SIZE") {
                unitSize[item.param_value] = item.param_desc;
              }
            }
            this.qyxz = qyxz;
            this.unitSize = unitSize
            resolve();
          });
      });
    },
    getEnterInfo() {
      this.$http.post("/api/enterprise_info", {}).then(res => {
        this.companyInfo = res.data;
        this.companyInfo.industry_id = Number(res.data.industry_id);
        this.companyInfo.info = res.data.info + "";
        if (res.data && res.data.area_id) {
          //let obj = this.getParentId(citys, res.data.area_id);
          let areas = util.getParentAreaByValue(citys,res.data.area_id)
          if (areas && areas.length > 0) {
            this.companyInfo.cityName = areas.map(m => m.label).reverse().join('/')
          }
        }
        this.initEnterDesc = res.data.enter_desc
      });
    },
    uploadCover(e) {
      this.companyInfo.license_imge = e.src;
      this.$http.post("/api/yyzz_ocr", { img_url: e.src }).then(res => {
        if (res.data.words_result) {
          this.companyInfo.firm_name = res.data.words_result['单位名称'].words
          this.companyInfo.firm_num = res.data.words_result['社会信用代码'].words
          this.companyInfo.address = res.data.words_result['地址'].words
          this.companyInfo.legal_person = res.data.words_result['法人'].words
          this.companyInfo.establish_date = res.data.words_result['成立日期'].words.replace(/(\d+)年(\d+)月(\d+)日/, '$1-$2-$3')
          this.companyInfo.register_capital = res.data.words_result['注册资本'].words.replace(/[^\d.]/ig,"")
        } else {
          this.$message.error("请上传清晰的营业执照！")
        }
      })
    },
    logoUploadCover(e) {
      this.companyInfo.logo = e.src;
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          /*         this.companyInfo.area_id;
                  this.companyInfo.area_id = this.companyInfo.area_id[
                    this.companyInfo.area_id.length - 1
                  ]; */
          this.$http
            .post("/api/recertification", this.companyInfo)
            .then(res => {
              this.getEnterInfo();
              this.active += 1;
              setTimeout(() => {
                window.location.reload()
              }, 500);
            });
          this.ccstatus = false;
        } else {
          return false;
        }
      });
    },
    recertification() {
      this.ccstatus = true;
    },
    getParentId(list, iid) {
      if (list && list.length > 0) {
        for (let o of list) {
          if (o.value == iid) return o;
          const o_ = this.getParentId(o.children, iid);
          if (o_) return o_;
        }
      }
    },
    sendVerifyEmail() {
      this.$http.post("/api/enterprise_email_attest", {}).then(res => {
        this.$message({
          type: "success",
          message:
            "激活邮件已发送到" +
            this.companyInfo.email +
            "邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户，以确保能收到简历。"
        });
      });
    },
    cancel() {
      this.edit = false;
    },
    save() {
      if (!this.form.firm_principal) {
        this.$message({
          type: "error",
          message: "请输入企业联系人"
        });
        return false;
      }
      if (!this.form.tel) {
        this.$message({
          type: "error",
          message: "请输入联系电话"
        });
        return false;
      } else if (!/^1[3456789]\d{9}$/.test(this.form.tel)) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号"
        });
        return false;
      }
      if (!this.form.email) {
        this.$message({
          type: "error",
          message: "请输入企业邮箱"
        });
        return false;
      } else if (!/^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/.test(this.form.email)) {
        this.$message({
          type: "error",
          message: "请输入正确的邮箱"
        });
        return false;
      }
      this.$http.post("/api/enterprise_update", this.form).then(res => {
        this.$message({
          type: "success",
          message: "保存成功"
        });
        this.edit = false;
        this.getEnterInfo();
      });
    },
    editInfo() {
      this.edit = true;
      this.form.firm_principal = this.companyInfo.firm_principal;
      this.form.tel = this.companyInfo.tel;
      this.form.email = this.companyInfo.email;
    },
    saveDesc() {
      if (!this.companyInfo.enter_desc) {
        this.$message({
          type: "error",
          message: "请输入企业简介"
        });
        return false;
      }
     
     
      this.$http.post("/api/enterprise_update_desc", this.companyInfo).then(res => {
        this.$message({
          type: "success",
          message: "保存成功"
        });
        this.edit_desc = false;
        this.getEnterInfo();
      });
    },
  }
};
</script>

<style lang="less" type="text/less" scoped>
.pageContainer {
  box-sizing: border-box;

  div,
  h3,
  p {
    box-sizing: border-box;
  }
}

.license_imge_css {
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  width: 181px;
  height: 256px;
  float: right;
  margin-right: 25px;
}

.input_css {
  width: 430px;
}

.companyInfo {
  background-color: #ffffff;
  font-size: 14px;
  color: #303133;
  position: relative;

  .baseInfo {
    position: relative;
    z-index: 1;
  }

  .ant-alert-success {
    width: 508px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    z-index: 99;

    /deep/ .ant-alert-message {
      display: none;
    }

    p {
      margin-bottom: 0;
    }
  }

  .state-pic {
    width: 160px;
    position: absolute;
    right: 32px;
    top: 20px;
  }

  .fail {
    width: 60%;
    margin: 0 0 0 30px;
    background-color: #fff1f0;
    border: 1px solid #ffa39e;
    border-radius: 4px;
    padding: 5px 10px;
    max-width: 50%;

    .anticon-close-circle {
      margin-right: 5px;
    }

    span {
      color: #1890ff;
      cursor: pointer;
      float: right;
    }
  }

  h3 {
    font-size: 16px;
    height: 62px;
    line-height: 62px;
    font-weight: bold;
    margin-bottom: 0;
    padding: 0 30px;

    p {
      border-bottom: 1px solid #e6e7eb;

      em {
        font-size: 14px;
        color: #909399;
        font-style: normal;
        font-weight: normal;
      }

      span {
        float: right;
        color: #909399;
        font-weight: normal;
        font-size: 14px;

        .anticon-form {
          color: #3378fa;
          margin-right: 5px;
          cursor: pointer;
        }
      }
    }
  }

  ul {
    padding: 0;
    width: 90%;
    padding: 0 30px 30px;
    margin-bottom: 0;
    position: relative;
    z-index: 1;

    li {
      list-style: none;
      margin-top: 16px;
      line-height: 24px;

      b {
        display: block;
        width: 160px;
        float: left;
        color: #909399;
        font-weight: normal;
        text-align: right;
      }

      span {
        display: block;
        margin-left: 100px;

        img {
          max-width: 100%;
        }
      }
    }
  }

  /deep/ .ant-form {
    background-color: #f6f8fc;
    padding: 24px 30px;

    .ant-form-item {
      width: 50%;

      label {
        color: #909399;
      }
    }

    .btnItem {
      display: flex;
      justify-content: flex-end;

      .cancel {
        margin-right: 10px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .companyInfo ul {
    width: 100%;
  }
}
</style>
